import React from 'react'
import PropTypes from 'prop-types'
import { useFormik } from '../../../../FormikProvider/FormikProvider'

import Button from '../../../../Button/Button'

import './GiftCardPaymentLabel.css'

export const GiftCardPaymentLabel = ({ canSubmit, loading = false }) => {
  const { submitForm } = useFormik()
  return (
    <div styleName='giftCardPaymentLabel'>
      <Button
        data-testid='apply-gift-card-button'
        onClick={submitForm}
        disabled={!canSubmit}
        loading={loading}
        style='link'
      >
          Apply
      </Button>
    </div>
  )
}

GiftCardPaymentLabel.propTypes = {
  canSubmit: PropTypes.bool.isRequired,
  loading: PropTypes.bool
}
